<template>
  <v-dialog v-model="dialog" max-width="560">
      <template #activator="{on}">
          <v-btn v-on="on" outlined color="accent" >Add Product</v-btn>
      </template>
      <v-card>
          <v-card-title>Add Product on Purchase Order</v-card-title>
          <v-card-text>
               <v-form ref="addForm">
                    <ProductAutocomplete v-model="model.product_id" @productSelected="setProduct($event)" :rules="[rules.required]" />
                    <v-text-field v-model="model.quantity" label="Quantity" :rules="[rules.required]" />
                    <v-text-field v-model="model.cost" label="Unit Cost" :suffix="currency" />
               </v-form>
          </v-card-text>
          <v-card-actions>
              <v-btn @click="close">Close</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="add">Add</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import ProductAutocomplete from "../forms/autocomplete/Product.vue"
export default {
    name:"AddProduct",
    components:{
        ProductAutocomplete
    },
    data: () => ({
        dialog:false,
        model:{
            product_id: null,
            quantity: 0,
            cost:0
        },
        product:null,
        
        rules: {
            required: value => !!value || "This field is mandatory.",
        },
    }),
    props:{
        currency:{
            type:String,
            default:''
        }
    },
    methods:{
        close(){
            this.model={
                    product_id: null,
                    quantity: 0,
                    cost:0
                }
            this.dialog=false
        },
        open(product) {
            this.model.product_id = product.id
            this.setProduct(product)
            this.dialog=true
        },
        add(){
            if (this.$refs.addForm.validate()) {
                this.$emit("added", this.model);
                this.model={
                    product_id: null,
                    quantity: 0,
                    cost:0
                }
                this.$refs.addForm.reset()
                this.$refs.addForm.resetValidation()
            }
        },
        setProduct(product)
        {
            this.product=product
            if(product){
                this.model.cost = product.cost
                this.model.product = product
            }
        }
    }
}
</script>

<style>

</style>